export const GTM_ID = 'GTM-PPQ9JM';
export const GA_ID = 'UA-32518546-1';
export const GTAG_ID = 'gtag_UA_32518546_1';

// Тестовы счетчик метрики 96479572
export const YANDEX_AB_METRIKA = 'metrika.17911543';
